import React from "react";

import Button from "../elements/Button";
import logo from "../assets/images/logo.png";

export default function BrandIcon() {
  return (
    <Button
      className="flex items-center gap-3 transition-opacity hover:opacity-90"
      type="link"
      href="/"
    >
      <img className="h-14 w-14 sm:h-16 sm:w-16" src={logo} alt="VR Food Products" loading="lazy" />
      <span className="hidden font-display text-2xl font-bold tracking-tight text-maroon-800 sm:inline">
        Food Products
      </span>
    </Button>
  );
}
